<template>
  <div class="graph-container">
    <div class="graph-header">
      <h5>Statistiques sur les 6 dernier mois</h5>
    </div>
    <apexchart
      height="550"
      style="width: 80%"
      :options="chartOptions"
      :series="series"
    ></apexchart>
  </div>
</template>

<script>
import serverVue from "../../api/server.vue";

export default {
  name: "DocumentStatGraph",
  props: ["series", "categories", "colors", "type"],
  data() {
    return {
      chartOptions: {
        chart: {
          zoom: {
            enabled: true,
            type: "xy",
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          show: true,
          width: 2,
          colors: ["transparent"],
        },
        xaxis: {
          type: 'datetime',
          labels: {
            formatter: function (value) {
              let date = new Date(value)
              date = date.getMonth() +1 + '/' + date.getFullYear()
              return date              
            },
          }, 
        },
        yaxis: {
          min: 0,
          max: 150,
          title: {
            text: "jours",
          },
        },
        fill: {
          type:'solid',
        },
        markers: {
          size: [6, 0]
        },
        stroke: {
         curve: 'smooth',
        },
        legend: {
          fontSize: 16,
          fontWeight: 700,
        },
        tooltip: {
          shared: false,
          intersect: true,
        },
      },
    };
  },
  mounted() {
    console.log(this.series);
  },
};
</script>


<style type="css" scoped>
.graph-container {
  margin: 0;
  padding: 0;
  min-height: 100px;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-around;
  flex-wrap: wrap;
}

.graph-header {
  position: relative;
  padding: 1em;
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

.graph-header > span {
  position: absolute;
  left: 0.5em;
  top: 0.5em;
}
</style>



// WEBPACK FOOTER //
// DocumentStatGraph.vue?e5e23b08